import { render, staticRenderFns } from "./MenuFooterComponent.vue?vue&type=template&id=54b00a3c&scoped=true&"
import script from "./MenuFooterComponent.vue?vue&type=script&lang=js&"
export * from "./MenuFooterComponent.vue?vue&type=script&lang=js&"
import style0 from "./MenuFooterComponent.vue?vue&type=style&index=0&id=54b00a3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b00a3c",
  null
  
)

export default component.exports